import * as React from "react";

function SvgOptimizelyX(props, ref) {
  return (
    <svg
      id="OptimizelyX_svg__Optimizely_Logo_Full_Color_Dark"
      data-name="Optimizely Logo Full Color Dark"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 66 66"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <defs>
        <style>
          {
            ".OptimizelyX_svg__cls-1{fill:#0037ff}.OptimizelyX_svg__cls-2{fill:#080738}"
          }
        </style>
      </defs>
      <path
        className="OptimizelyX_svg__cls-1"
        d="M30.69 11.44a24 24 0 00-6.23 10.78 24.3 24.3 0 016-.81l-6.8 6.79a23.84 23.84 0 00.34 4.47l10.89-10.89A25.46 25.46 0 0139 22.89a10 10 0 011.39-1.72 10.29 10.29 0 0114.54 14.56 9.85 9.85 0 01-1.71 1.38 24.5 24.5 0 011.12 4.11L43.42 52.14a23.27 23.27 0 004.49.37l6.78-6.84a23.78 23.78 0 01-.82 6 24.06 24.06 0 10-23.18-40.23z"
        transform="translate(-6.59 -4.34)"
      />
      <path
        className="OptimizelyX_svg__cls-1"
        d="M38.37 32.88a10.41 10.41 0 01-1-3.88l-6.19 6.19-4.69 4.71a24.5 24.5 0 001.9 3l6.69-6.69zM47.11 38.73a10 10 0 01-3.88-1L39.94 41l-6.69 6.68a22.31 22.31 0 003 1.9L41 44.9z"
        transform="translate(-6.59 -4.34)"
      />
      <path
        className="OptimizelyX_svg__cls-2"
        d="M37.39 29A10.24 10.24 0 0139 22.89a25.46 25.46 0 00-4.11-1.11L24 32.67a23.69 23.69 0 002.51 7.21zM47.11 38.73L36.22 49.67a24 24 0 007.2 2.52l10.92-11a24.5 24.5 0 00-1.12-4.11 10.23 10.23 0 01-6.11 1.65zM53.89 51.67a23.82 23.82 0 00.8-6l-6.8 6.8a23.88 23.88 0 006-.8zM24.42 22.22a24.37 24.37 0 00-.82 6l6.8-6.79a24.6 24.6 0 00-5.98.79zM43.23 37.74a10.12 10.12 0 01-4.84-4.85l-10 10a22.45 22.45 0 002.3 2.57 23.26 23.26 0 002.6 2.26z"
        transform="translate(-6.59 -4.34)"
      />
      <path
        className="OptimizelyX_svg__cls-1"
        d="M24.42 22.22a24.08 24.08 0 00-17.83 23l17-17a23.92 23.92 0 01.83-6zM30.9 69.52a24.05 24.05 0 0023-17.85 24.36 24.36 0 01-6 .81zM23.37 38.19a11 11 0 011.72-1.39A24.44 24.44 0 0124 32.67l-17 17a23.92 23.92 0 002.52 7.2L20.37 46a10.27 10.27 0 013-7.81zM39.31 51a10.24 10.24 0 01-9.21 4.72L19.2 66.67a23.45 23.45 0 007.21 2.52l17-17a23.39 23.39 0 01-4.1-1.19zM23.37 52.74a10.12 10.12 0 01-2-2.85l-10 10a24.79 24.79 0 002.32 2.59 23.26 23.26 0 002.6 2.26l10-10a10.25 10.25 0 01-2.92-2z"
        transform="translate(-6.59 -4.34)"
      />
    </svg>
  );
}

export default React.forwardRef(SvgOptimizelyX);
